import React from 'react';
import { Card, CardBody } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import { FaTrophy, FaNewspaper, FaAward } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { MdSource, MdFilterListAlt, MdOutlineStickyNote2, MdPeople } from "react-icons/md";
import { HiTemplate } from "react-icons/hi";

const AdminAwardTypeMenu = ({ page, id }) => {
    const history = useHistory();

    return (
        <>
            <Card className="mb-3">
                <CardBody>
                    <Card style={{ cursor: 'pointer' }}
                        className={`${page === `AWARDS` ? 'active text-center profile-left-btn text-left' : 'text-center profile-left-btn'}`}
                        onClick={() => history.push(`/admin/industry/award?id=${id}`)}>
                        <CardBody className='entrant-widget px-2 py-2'>
                        <FaTrophy className='entrant-left-icon' />EVENTS
                        </CardBody>
                    </Card>
                    <Card style={{ cursor: 'pointer' }}
                        className={`${page === `EDITORS_NOTE` ? 'mt-3 active text-center profile-left-btn text-left' : 'mt-3 text-center profile-left-btn'}`}
                        onClick={() => history.push(`/admin/industry/editors-note?id=${id}`)}>
                        <CardBody className='entrant-widget px-2 py-2'>
                        <MdOutlineStickyNote2 className='entrant-left-icon' />EDITOR'S NOTES
                        </CardBody>
                    </Card>
                    <Card style={{ cursor: 'pointer' }}
                        className={`${page === `ARTICLES` ? 'mt-3 active text-center profile-left-btn text-left' : 'mt-3 text-center profile-left-btn'}`}
                        onClick={() => history.push(`/admin/industry/articles?id=${id}`)}>
                        <CardBody className='entrant-widget px-2 py-2'>
                        <FaNewspaper className='entrant-left-icon' />ARTICLES
                        </CardBody>
                    </Card>
                    <Card style={{ cursor: 'pointer' }}
                        className={`${page === 'SOURCES' ? 'active mt-3 text-center profile-left-btn text-left' : 'mt-3 text-center profile-left-btn'}`}
                        onClick={() => history.push(`/admin/industry/sources?id=${id}`)}>
                        <CardBody className='entrant-widget px-2 py-2'>
                        <MdSource className='entrant-left-icon' />SOURCES
                        </CardBody>
                    </Card>
                    <Card style={{ cursor: 'pointer' }}
                        className={`${page === 'FILTERS' ? 'active mt-3 text-center profile-left-btn text-left' : 'mt-3 text-center profile-left-btn'}`}
                        onClick={() => history.push(`/admin/industry/filters?id=${id}`)}>
                        <CardBody className='entrant-widget px-2 py-2'>
                        <MdFilterListAlt className='entrant-left-icon' />FILTERS
                        </CardBody>
                    </Card>
                    <Card style={{ cursor: 'pointer' }}
                        className={`${page === 'DELIVERY' ? 'active mt-3 text-center profile-left-btn text-left' : 'mt-3 text-center profile-left-btn'}`}
                        onClick={() => history.push(`/admin/industry/delivery?id=${id}`)}>
                        <CardBody className='entrant-widget px-2 py-2'>
                        <HiTemplate className='entrant-left-icon' />DELIVERY
                        </CardBody>
                    </Card>
                    <Card style={{ cursor: 'pointer' }}
                        className={`${page === 'SUBSCRIBERS' ? 'active mt-3 text-center profile-left-btn text-left' : 'mt-3 text-center profile-left-btn'}`}
                        onClick={() => history.push(`/admin/industry/subscribers?id=${id}`)}>
                        <CardBody className='entrant-widget px-2 py-2'>
                        <MdPeople className='entrant-left-icon' />SUBSCRIBERS
                        </CardBody>
                    </Card>
                    <Card style={{ cursor: 'pointer' }}
                        className={`${page === 'PAST AWARDS' ? 'active mt-3 text-center profile-left-btn text-left' : 'mt-3 text-center profile-left-btn'}`}
                        onClick={() => history.push(`/admin/award-type/past-awards?id=${id}`)}>
                        <CardBody className='entrant-widget px-2 py-2'>
                        <FaAward className='entrant-left-icon' />PAST AWARDS
                        </CardBody>
                    </Card>
                </CardBody>
            </Card>
        </>
    )
}

export default AdminAwardTypeMenu;
